export const HEALF_OPS_SUPPORT_EMAIL = "billy@healf.com";
export const HEALF_IT_CONTACT_EMAIL = "billy@healf.com, alamk@healf.com";
export const HEALF_OPERATIONS_CONTACT_EMAIL = "billy@healf.com";
export const CHILD_PO_DEFAULT_SENDER_EMAIL = "yasin@healf.com";

export const MAX_VENDOR_EMAILS = 30;
export const MAX_USER_ACCOUNT_SUPERVISOR_EMAILS = 12;
